import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { color } from '../templates/Ui';
const StyledTextarea = styled.textarea `
    transition: all 200ms ease-in-out;
    padding: ${props => (props.bordered ? '17px 10px' : '10px 0px 15px 0px')};
    background-color: ${props => (props.readOnly ? '#f6f6f6' : 'white')};
    border: none;
    border-bottom: 1px solid ${color.border.base};
    width: 100%;
    outline: none;
    font-size: 16px;
    font-weight: 600;
    color: ${props => props.theme.primary.base};
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    resize: vertical;

    &:focus {
        border-bottom-color: transparent;

        ~ .focus-border {
            transform: scaleX(1);
        }
    }

    &::placeholder {
        color: rgba(41, 48, 87, 0.25);
        font-weight: 400;
        opacity: 1;
    }

    &:-ms-input-placeholder {
        color: rgba(41, 48, 87, 0.25);
        font-weight: 400;
    }

    &::-ms-input-placeholder {
        color: rgba(41, 48, 87, 0.25);
        font-weight: 400;
    }

    &:disabled {
        background-color: ${color.border.base};
    }
`;
const Textarea = props => (_jsx(StyledTextarea, { ...props }));
export default Textarea;
